var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 2.22222C5.70445 2.22222 2.22222 5.70445 2.22222 10C2.22222 14.2955 5.70445 17.7778 10 17.7778C14.2955 17.7778 17.7778 14.2955 17.7778 10C17.7778 5.70445 14.2955 2.22222 10 2.22222ZM10 7.77778C10.6137 7.77778 11.1111 8.27524 11.1111 8.88889V14.4444C11.1111 15.0581 10.6137 15.5556 10 15.5556C9.38635 15.5556 8.88889 15.0581 8.88889 14.4444V8.88889C8.88889 8.27524 9.38635 7.77778 10 7.77778ZM10 4.44444C10.6137 4.44444 11.1111 4.94191 11.1111 5.55556C11.1111 6.16921 10.6137 6.66667 10 6.66667C9.38635 6.66667 8.88889 6.16921 8.88889 5.55556C8.88889 4.94191 9.38635 4.44444 10 4.44444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.28dbd5d2f3f8198d8d33cb47d06c3261.svg";
export { ForwardRef as ReactComponent };